import React from 'react'
import { motion } from 'framer-motion'
import Contact from '../components/Contact'
import './ContactPage.css'

const ContactPage = () => {
  return (
    <div className="contact-page">
      <div className="container">
        <motion.div
          className="page-header"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="page-title">Get In Touch</h1>
          <p className="page-description">
            Have a project in mind or want to collaborate? I'd love to hear from you.
            Let's create something amazing together.
          </p>
        </motion.div>
        <Contact />
      </div>
    </div>
  )
}

export default ContactPage
